module.exports = __webpack_public_path__ + "img/gb-wls.f8b16c80.svg";